import React from 'react';
import Button from 'components/Button/Button';
import { FormattedMessage } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import classes from 'components/JoinModal/JoinModal.module.scss';
import { hooks } from '@lifesize/clients.sdk';

const JoinButtons = (props) => {
  const { localPrimaryStream } = hooks.useMedia();
  let buttonStyle = { minWidth: 151, padding: 0, width: 222, height: 50, lineHeight: '52px' };
  if (props.isGuest) {
    buttonStyle = { ...buttonStyle, minWidth: 304, width: 304 };
  }

  const joinButtonClasses = [
    classes.joinButtons,
    props.isGuest ? classes.guestButton : ''
  ].join(' ');

  return (<div className={joinButtonClasses}>
    <Button
      onClick={props.call}
      disabled={props.isAcquiringPrimaryStream || !localPrimaryStream}
      style={buttonStyle}
    >
      <FormattedMessage
        id="components.joinModal.join"
        defaultMessage="Join"
      />
    </Button>
  </div>);
};

JoinButtons.propTypes = {
  call: PT.func,
  isGuest: PT.bool,
  isAcquiringPrimaryStream: PT.bool
};

export default JoinButtons;
